var _Skeleton, _div;
import { Skeleton } from "@crehana/compass.ui";
import cn from "clsx";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CourseEnrollmentCardSkeleton = function CourseEnrollmentCardSkeleton(_ref) {
  var className = _ref.className,
    isDark = _ref.isDark;
  return /*#__PURE__*/_jsxs("div", {
    className: cn('tw-flex tw-flex-col tw-rounded-0.4 tw-overflow-hidden', isDark ? 'bg-base-lighter-24' : 'bg-white shadow-card', className),
    children: [_Skeleton || (_Skeleton = /*#__PURE__*/_jsx(Skeleton, {
      className: "tw-w-full tw-flex-shrink-0 tw-pt-[54%]"
    })), _div || (_div = /*#__PURE__*/_jsxs("div", {
      className: "tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-between tw-p-1.6",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "tw-flex tw-flex-col tw-mb-1.2",
        children: [/*#__PURE__*/_jsx(Skeleton, {
          className: "tw-w-full tw-h-2 tw-mb-0.4"
        }), /*#__PURE__*/_jsx(Skeleton, {
          className: "w-1/3 tw-h-2"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "tw-flex tw-flex-col",
        children: [/*#__PURE__*/_jsx(Skeleton, {
          className: "w-2/3 tw-h-1.6 tw-mb-0.8"
        }), /*#__PURE__*/_jsx(Skeleton, {
          className: "w-2/3 tw-h-1.6 tw-mb-2.4"
        }), /*#__PURE__*/_jsx(Skeleton, {
          className: "tw-w-full tw-h-4.8 tw-rounded-0.4"
        })]
      })]
    }))]
  });
};
export default CourseEnrollmentCardSkeleton;